import { Fragment, useEffect, useState } from "react";
import { backend_api_url, cluster, getExplorerUrl, getUserSessionData, isUserAdmin } from "./constants";
import ReactPaginate from "react-paginate";

const UserContainer = (props: any) => {

    const [listingJsx, setListingJsx] = useState<JSX.Element[] | null>(null)

    const [page, setPage] = useState(0);      
    const [pageCount, setPageCount] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
     
     const handlePageClick = (event) => { 
        fetchAllUsers(event.selected);
 
     };

    const fetchAllUsers = async (pageNum): Promise<any> => {
        setListingJsx([]);
        const userData = getUserSessionData();

        //setCurrentUserName(userData.username);
        setPage(pageNum);

        const params = {
            token: userData.token,
            secret: userData.secret,
            page: pageNum,
        }

        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(params)
        };
        fetch(backend_api_url + 'api/v1/users/all', requestOptions)
            .then(response => response.json())
            .then(data => {
                if(data.status === 1) {
                    showAllUsers(data.users);
                    setPageCount(data.pageCount);
                    setTotalItems(data.total);

                }
            });
	};
  
    const changePending = (id, e) => {
        // console.log(id);
        // console.log(e.target.value);

        const userData = getUserSessionData();

        //setCurrentUserName(userData.username);

        const params = {
            token: userData.token,
            secret: userData.secret,
            id: id,
            value: e.target.value
        }

        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(params)
        };
        fetch(backend_api_url + 'api/v1/users/update-status', requestOptions)
            .then(response => response.json())
            .then(data => {
                if(data.status === 1) {
                    ;//showAllUsers(data.users);
                    
                }
            });
    }

    const showAllUsers = async (users: any[]): Promise<any> => {
  
         setListingJsx( users.map( (info, index) => <Fragment key={index + (new Date()).getTime()}> 
            <tr>
                <td>{info.date}</td>
                <td><a  rel="noreferrer" href={"/user/" + info.username} target="_blank">{info.username}</a></td>
                <td><a  rel="noreferrer" href={"/wallet/"+info.username} target="_blank">View Wallet</a></td>
                <td>
                <select onChange={(e) => changePending(info.id, e)}>
                        {
                            info.isOver === 1 && <Fragment>
                                    <option disabled value="0">New</option>
                                    <option selected={info.status === 1} value="1">Unlocked</option>   
                                    <option selected={info.status === 2} value="2">Locked</option>   
                                    <option selected={info.status === 3} value="3">Under Review</option>    
                            </Fragment>
                        }
                        {
                            info.isOver === 0 && <Fragment>
                                    <option selected={info.status === 1} value="0">New</option>
                                    <option selected={info.status === 1} value="1">Unlocked</option>   
                                    <option selected={info.status === 2} value="2">Locked</option>   
                                    <option selected={info.status === 3} value="3">Under Review</option>    
                            </Fragment>
                        }
                    </select>    
                </td>
                <td>{info.email}</td>
                
            </tr>
            </Fragment>) );
 
     };
 
   

	useEffect(() => {
		
        //fetchAllMyGachas();
        if(!isUserAdmin()) {
            window.location.href = '/';
        }
        fetchAllUsers(0);
	  }, []);

      props.setClassInfo("accountPg");

    return (
        <Fragment>
            <div className="contents">
               <a href="/admin/users">Users</a>&nbsp;|&nbsp;               
               <a href="/admin/creators">Creators</a>&nbsp;|&nbsp;               
               <a href="/admin/collections">Collections</a>&nbsp;|&nbsp;               
               Purchases: <a href="/admin/purchases/credits">Credits</a>&nbsp;-&nbsp;<a href="/admin/purchases/nfts">NFTs</a>&nbsp;|&nbsp;
               <a href="/admin/actions">Actions</a>

               <table className="walletActivityTable admin-infos"  style={{ "borderSpacing" : 0}} >
                <tbody>
                    <tr>
                    <td align="center"><b>TIME</b></td>
                    <td align="center"><b>USER</b></td>
                    <td align="center"><b>WALLET</b></td>
                    <td align="center"><b>STATUS</b></td>
                    <td align="center"><b>EMAIL</b></td>
                    </tr>	
 
                    {totalItems > 0  && listingJsx}

                </tbody>
                </table>

                {/* {props.items} */}
                            {
                            pageCount > 1 &&
                            <div style={{"width": "100%", "textAlign" : "center", "marginTop" : "20px"}}>
                                <ReactPaginate
                    
                                breakLabel="..."
                                nextLabel=">"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={5}
                                pageCount={pageCount}
                                previousLabel="<"
                    
                                forcePage={page}
                    
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                containerClassName="pagination"
                                activeClassName="active"
                    
                                renderOnZeroPageCount={null}
                                />
                            </div>
                            }
            </div>
                
         
        </Fragment>
    );
}

export default UserContainer;